import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { ROUTES, PAGINAS, FUNCIONALIDADES } from '../../../routes';
import { getTipoNaturezaCrime, cadastrarTipoNaturezaCrime, alterarTipoNaturezaCrime, excluirTipoNaturezaCrime } from './tipos_naturezas_crimes_service';
import { CadastroBasicoNomeSituacaoForm } from '../../../components/CadastroBasicoNomeSituacaoForm';
export var TiposNaturezasCrimesAlterar = function () {
    var services = {
        getItem: getTipoNaturezaCrime,
        cadastrarItem: cadastrarTipoNaturezaCrime,
        alterarItem: alterarTipoNaturezaCrime,
        excluirItem: excluirTipoNaturezaCrime,
    };
    return _jsx(CadastroBasicoNomeSituacaoForm, { pagina: PAGINAS.TIPOS_NATUREZAS_CRIMES, paginaPermissao: FUNCIONALIDADES.TIPOS_NATUREZAS_CRIMES, rota: ROUTES.TIPOS_NATUREZAS_CRIMES, services: services });
};
export default TiposNaturezasCrimesAlterar;
